/**
 * Toast, confirm dialog, and modal overlays.
 * Faithful to the monolith's showToast / confirmApp / confirmResolve / modal.
 */

import { byId } from './dom';

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function showToast(msg: string, dur = 2000): void {
  const t = byId('toast');
  if (!t) return;
  clearTimeout(toastTimer);
  t.textContent = msg;
  t.classList.add('show');
  toastTimer = setTimeout(() => t.classList.remove('show'), dur);
}

let confirmResolver: ((value: boolean) => void) | null = null;

/** Show a confirm dialog; resolves true (confirmed) or false (cancelled). */
export function confirmApp(
  title: string,
  msg: string,
  okLabel = 'Confirm',
  okClass = 'btn-danger'
): Promise<boolean> {
  return new Promise((resolve) => {
    confirmResolver = resolve;
    const title$ = byId('confirm-title');
    const msg$ = byId('confirm-msg');
    if (title$) title$.textContent = title;
    if (msg$) msg$.textContent = msg;
    const btn = byId('confirm-ok-btn');
    if (btn) {
      btn.textContent = okLabel;
      btn.className = 'btn ' + okClass;
    }
    byId('confirm-overlay')?.classList.add('open');
  });
}

/** Resolve the open confirm dialog (wired to its buttons via inline handlers). */
export function confirmResolve(value: boolean): void {
  byId('confirm-overlay')?.classList.remove('open');
  if (confirmResolver) {
    confirmResolver(value);
    confirmResolver = null;
  }
}

export function showModal(html: string): void {
  const content = byId('modal-content');
  if (content) content.innerHTML = html;
  byId('modal-overlay')?.classList.add('open');
}

export function closeModal(): void {
  byId('modal-overlay')?.classList.remove('open');
}
